<template>
  <div style="width: 100%">
    <v-autocomplete
      class="tema-eixo-combo"
      id="temas-select"
      v-model="filter.municipio"
      item-text="nome"
      filled
      item-name="nome"
      item-value="nome"
      :items="municipios"
      label="Municípios"
      placeholder="Selecione um lugar"
      v-on:change="$emit('onChange')"
      clearable
      :rules="rules"
      :return-object="true"
      :disabled="!this.uf"
      :hide-details="'auto'"
    >
      <template slot="no-data"> Nenhum Municipio retornado </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { municipioAPI } from "@/apis";

export default {
  name: "ComboMunicipiosUf",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    filter: {
      type: Object,
      default: () => {
        ({ municipioId: null });
      },
    },

    label: {
      type: String,
      default: "",
    },
    uf: {
      type: String,
      default: "",
    },
    disabled: { type: Boolean, default: false },
  },
  watch: {
    uf(old, a) {
      if (!old) {
        this.municipios = [];
      }
      this.load(old);
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    load(uf) {
      municipioAPI
        .obterPorUf(uf)
        .then(({ data }) => {
          this.municipios = data.data;
        })
        .catch((resp) => {
          console.log("Erro uf: ", resp);
          this.$notification.error("Erro ao obter Municipios");
        });
    },
  },
  data() {
    return {
      municipios: [],
    };
  },
};
</script>

<style scoped>
/* .tema-eixo-combo {
  padding: 0 0 20px;
} */
</style>
